import Service from './service'
export var FaceRecognizeMessageType;
(function (FaceRecognizeMessageType) {
  FaceRecognizeMessageType["FACE_RECOGNIZE_INFO"] = "FACE_RECOGNIZE_INFO"
  FaceRecognizeMessageType["FACE_RECOGNIZE_GENERAL"] = "FACE_RECOGNIZE_GENERAL"
  FaceRecognizeMessageType["FACE_RECOGNIZE_GENERAL_SETTED"] = "FACE_RECOGNIZE_GENERAL_SETTED"
  FaceRecognizeMessageType["FACE_RECOGNIZE_MATCH_SCORE"] = "FACE_RECOGNIZE_MATCH_SCORE"
  FaceRecognizeMessageType["FACE_MATCH_SCORE"] = "FACE_MATCH_SCORE"
  FaceRecognizeMessageType["FACE_ADD_START"] = "FACE_ADD_START"
  FaceRecognizeMessageType["FACE_ADD_STATUS"] = "FACE_ADD_STATUS"
})(FaceRecognizeMessageType || (FaceRecognizeMessageType = {}))
export var ApiFaceRecognizeMessageType;
(function (ApiFaceRecognizeMessageType) {
  ApiFaceRecognizeMessageType["GENERAL_SETTED"] = "system.general.setted"
  ApiFaceRecognizeMessageType["FACE_RECOGNIZE_INFO"] = "face.recognize.info"
  ApiFaceRecognizeMessageType["FACE_RECOGNIZE_GENERAL"] = "face.recognize.general"
  ApiFaceRecognizeMessageType["FACE_RECOGNIZE_CONTROL"] = "face.recognize.control"
  ApiFaceRecognizeMessageType["FACE_ADD_STATUS"] = "face.add.status"
  ApiFaceRecognizeMessageType["FACE_GENERAL_FRAME"] = "face.general.frame"
  ApiFaceRecognizeMessageType["GENERAL_TOUCH"] = "system.general.touch"
  ApiFaceRecognizeMessageType["FACE_MATCH_SCORE"] = "face.match.score"
})(ApiFaceRecognizeMessageType || (ApiFaceRecognizeMessageType = {}))
export var FaceInfoEmotions;
(function (FaceInfoEmotions) {
  FaceInfoEmotions["HAPPINESS"] = "HAPPINESS"
  FaceInfoEmotions["FEAR"] = "FEAR"
  FaceInfoEmotions["ANGER"] = "ANGER"
  FaceInfoEmotions["NEUTRAL"] = "NEUTRAL"
  FaceInfoEmotions["SADNESS"] = "SADNESS"
  FaceInfoEmotions["SURPRISE"] = "SURPRISE"
  FaceInfoEmotions["UNKNOWN"] = "UNKNOWN"
})(FaceInfoEmotions || (FaceInfoEmotions = {}))
export var FaceTrainStep;
(function (FaceTrainStep) {
  /** Лицо пропало в процессе запоминания */
  FaceTrainStep[FaceTrainStep["LOST_FACE"] = 0] = "LOST_FACE"
  /** Недостаточно кадров для запоминания */
  FaceTrainStep[FaceTrainStep["NOT_ENOUGH_FRAMES"] = 1] = "NOT_ENOUGH_FRAMES"
  /** В процессе сохранения кадров */
  FaceTrainStep[FaceTrainStep["SAVE_FRAMES_PROCESS"] = 2] = "SAVE_FRAMES_PROCESS"
  /** Процесс сохранения кадров завершился */
  FaceTrainStep[FaceTrainStep["SAVE_FRAMES_FINISHED"] = 3] = "SAVE_FRAMES_FINISHED"
  /** Обработка кадров */
  FaceTrainStep[FaceTrainStep["PROCESSING_FRAMES"] = 4] = "PROCESSING_FRAMES"
  /** Лицо прошло процесс запоминания */
  FaceTrainStep[FaceTrainStep["FACE_TRAINED"] = 5] = "FACE_TRAINED"
  /** Лицо уже есть в базе */
  FaceTrainStep[FaceTrainStep["FACE_IN_DB"] = 6] = "FACE_IN_DB"
  /** База лиц заполнена */
  FaceTrainStep[FaceTrainStep["DB_IS_FULL"] = 7] = "DB_IS_FULL"
})(FaceTrainStep || (FaceTrainStep = {}))
var FaceId;
(function (FaceId) {
  /** Лицо потеряно */
  FaceId[FaceId["Lost"] = -2] = "Lost"
  /** Лицо распознается */
  FaceId[FaceId["Recognizing"] = -1] = "Recognizing"
})(FaceId || (FaceId = {}))
export var FaceType;
(function (FaceType) {
  /** Лицо отсутствует */
  FaceType[FaceType["None"] = 0] = "None"
  /** Лицо распознается */
  FaceType[FaceType["Recognizing"] = 1] = "Recognizing"
  /** Лицо распознано и найдено в базе лиц */
  FaceType[FaceType["Known"] = 2] = "Known"
  /** Лицо распознано и отсутствует в базе лиц */
  FaceType[FaceType["Unknown"] = 3] = "Unknown"
})(FaceType || (FaceType = {}))
export var Gender;
(function (Gender) {
  /** Пол неизвестен */
  Gender[Gender["UNKNOWN"] = 0] = "UNKNOWN"
  /** Мужчина */
  Gender[Gender["MALE"] = 1] = "MALE"
  /** Женщина */
  Gender[Gender["FEMALE"] = 2] = "FEMALE"
})(Gender || (Gender = {}))
/**
 * Сервис для работы с распознаванием лиц
 * @version 0.0.1
 * @since 1.9.0
 */
export default class FaceRecognizeService extends Service {
  constructor(messageChannel) {
    super(messageChannel)
    this.info = []
    const messageHandler = (message) => {
      switch (message.type) {
        case ApiFaceRecognizeMessageType.FACE_RECOGNIZE_INFO:
          this.info = []
          for (const i of Object.keys(message.info)) {
            this.info.push(message.info[i])
          }
          this.broadcast(FaceRecognizeMessageType.FACE_RECOGNIZE_INFO, this.info)
          break
        case ApiFaceRecognizeMessageType.FACE_RECOGNIZE_GENERAL:
          this.broadcast(FaceRecognizeMessageType.FACE_RECOGNIZE_GENERAL, message.general)
          break
        case ApiFaceRecognizeMessageType.GENERAL_SETTED:
          if (typeof message.setted_id === 'number') {
            this.broadcast(FaceRecognizeMessageType.FACE_RECOGNIZE_GENERAL_SETTED, message.setted_id)
          }
          break
        case ApiFaceRecognizeMessageType.FACE_ADD_STATUS:
          if (typeof message.status === 'number') {
            this.broadcast(FaceRecognizeMessageType.FACE_ADD_STATUS, message.status)
          }
          break
        case ApiFaceRecognizeMessageType.FACE_GENERAL_FRAME:
          this.resolve(this.waiters.generalFrame, message.image)
          break
        case ApiFaceRecognizeMessageType.FACE_MATCH_SCORE:
          this.broadcast(FaceRecognizeMessageType.FACE_RECOGNIZE_MATCH_SCORE, message.score)
          this.resolve(this.waiters.photoMatch, message.score)
          break
      }
    }
    this.waiters = {
      generalFrame: [],
      photoMatch: [],
    }
    this.messageChannel.subscribe(ApiFaceRecognizeMessageType.GENERAL_SETTED, messageHandler)
    this.messageChannel.subscribe(ApiFaceRecognizeMessageType.FACE_RECOGNIZE_INFO, messageHandler)
    this.messageChannel.subscribe(ApiFaceRecognizeMessageType.FACE_RECOGNIZE_GENERAL, messageHandler)
    this.messageChannel.subscribe(ApiFaceRecognizeMessageType.FACE_ADD_STATUS, messageHandler)
    this.messageChannel.subscribe(ApiFaceRecognizeMessageType.FACE_GENERAL_FRAME, messageHandler)
    this.messageChannel.subscribe(ApiFaceRecognizeMessageType.FACE_MATCH_SCORE, messageHandler)
  }
  /**
     * Получен шаг добавления лица в базу
     * (в том числе временную)
     * Если запускалось знакомство, то получение FACE_TRAINED значит,
     * что знакомство успешно произошло
     * @since 1.10.0
     *
     * @param {(step: FaceTrainStep) => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof FaceRecognizeService
     *
     * @example <caption>Получен шаг добавления лица в базу</caption>
     * robot.faceRecognizeService.onFaceAddStatus((step) => {
     *   ...
     * })
     */
  onFaceAddStatus(callback) {
    return this.subscribe(FaceRecognizeMessageType.FACE_ADD_STATUS, callback)
  }
  /**
     * Разрешить автоматическое слежение за лицами/смену главного
     * В случае отключения необходимо вручную задавать лицо для слежения.
     * @since 1.10.0
     *
     * @param {boolean} status
     * @memberof FaceRecognizeService
     *
     * @example <caption>Разрешить автоматическое слежение за лицами</caption>
     * robot.faceRecognizeService.autoTracking(status)
     */
  autoTracking(status) {
    this.messageChannel.send({
      type: ApiFaceRecognizeMessageType.FACE_RECOGNIZE_CONTROL,
      tracking_auto: status,
    })
  }
  /**
     * Добавить лицо текущего главного в базу пользователей
     * (т.н. "старое" знакомство)
     * Требует присутствие лица в кадре
     * Статус и успех добавления отслеживается через onFaceAddStatus
     * @since 1.10.0
     *
     * @param {number} uniqueId - уникальный идентификатор для добавления в базу
     * @memberof FaceRecognizeService
     *
     * @example <caption>Добавить лицо текущего главного в базу пользователей</caption>
     * robot.faceRecognizeService.addFace(uniqueId)
     */
  addFace(uniqueId) {
    this.broadcast(FaceRecognizeMessageType.FACE_ADD_START)
    this.messageChannel.send({
      type: ApiFaceRecognizeMessageType.FACE_RECOGNIZE_CONTROL,
      add_face: uniqueId.toString(),
    })
  }
  /**
     * Удалить пользователя из базы пользователей
     * @since 1.10.0
     *
     * @param {number} uniqueId - Идентификатор удаляемого пользователя в базе
     * @memberof FaceRecognizeService
     *
     * @example <caption>Удалить пользователя из базы пользователей</caption>
     * robot.faceRecognizeService.delFace(uniqueId)
     */
  delFace(uniqueId) {
    this.messageChannel.send({
      type: ApiFaceRecognizeMessageType.FACE_RECOGNIZE_CONTROL,
      del_face: uniqueId,
    })
  }
  /**
     * Запомнить пользователя из временной базы в постоянную
     * (т.н. "новое" знакомство)
     * Не требует присутствия лица в кадре
     * Статус и успех добавления отслеживается через onFaceAddStatus
     * @since 1.10.0
     *
     * @param {number} id - идентификатор во временной базе лиц
     * @param {number} uniqueId - уникальный идентификатор для добавления в постоянную базу
     * @memberof FaceRecognizeService
     *
     * @example <caption>Разрешить движение головы для слежения за лицом</caption>
     * robot.faceRecognizeService.tempToGeneral(id, uniqueId)
     */
  tempToGeneral(id, uniqueId) {
    this.messageChannel.send({
      type: ApiFaceRecognizeMessageType.FACE_RECOGNIZE_CONTROL,
      id_temp: id,
      id_main: uniqueId,
    })
  }
  /**
     * Информация о лицах перед роботом
     *
     * Массив всегда имеет какую-то длину, т.к. потерянные лица буду иметь структуру:
     * { id: -2, type: -2, ... }
     * Поэтому не стоит ориентироваться на длину.
     * Если хотите получить актуальны список лиц, то необходимо отфильтровать массив
     *
     * @since 1.10.0
     *
     * @param {(info: Array<FaceStructure>) => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof FaceRecognizeService
     *
     * @example <caption>Информация о лицах перед роботом</caption>
     * robot.faceRecognizeService.onInfo((info) => {
     *   ...
     * })
     *
     * @example <caption>Получить распознанные лица</caption>
     * robot.faceRecognizeService.onInfo((info) => {
     *   const faces = info.filter(face => face.type > 1)
     * })
     *
     * @example <caption>Получить кол-во лиц перед роботом (в том числе еще не распознанных)</caption>
     * robot.faceRecognizeService.onInfo((info) => {
     *   const faces = info.filter(face => face.type > 0)
     * })
     */
  onInfo(callback) {
    return this.subscribe(FaceRecognizeMessageType.FACE_RECOGNIZE_INFO, callback)
  }
  /**
     * Получить информацию о лицах перед роботом
     * @since 1.10.0
     *
     * @return {*}  {Array<FaceStructure>}
     * @memberof FaceRecognizeService
     *
     * @example <caption>Получить информацию о лицах перед роботом</caption>
     * const info = robot.faceRecognizeService.getInfo()
     */
  getInfo() {
    return this.info
  }
  /**
     * Получен результат сходства лица и фотографии
     * (процент сходства от 0 до 100)
     * @since 1.10.0
     *
     * @param {(scope: number) => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof FaceRecognizeService
     *
     * @example <caption>Получен результат сходства лица и фотографии</caption>
     * robot.faceRecognizeService.onScore((scope) => {
     * if (scope > 70) ...
     *   ...
     * })
     */
  onScore(callback) {
    return this.subscribe(FaceRecognizeMessageType.FACE_RECOGNIZE_MATCH_SCORE, callback)
  }
  /**
     * Назначено новое главное лицо
     * @since 1.10.0
     *
     * @param {(id: number) => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof FaceRecognizeService
     *
     * @example <caption>Назначено новое главное лицо</caption>
     * robot.faceRecognizeService.onGeneral((id) => {
     *   console.log('New general is', id)
     * })
     */
  onGeneral(callback) {
    return this.subscribe(FaceRecognizeMessageType.FACE_RECOGNIZE_GENERAL, callback)
  }
  /**
     * При ручном выборе главного на видеопотоке выбрано распознанное лицо
     * (началась процедура назначения выбранного лица главным,
     * в случае её успешного завершения придёт onGeneral)
     * @since 1.10.0
     *
     * @param {(settedId: number) => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof FaceRecognizeService
     *
     * @example <caption>Сигнал об ошибке</caption>
     * robot.faceRecognizeService.onGeneralSetted((settedId) => {
     *   ...
     * })
     */
  onGeneralSetted(callback) {
    return this.subscribe(FaceRecognizeMessageType.FACE_RECOGNIZE_GENERAL_SETTED, callback)
  }
  /**
     * Назначить главного по клику в видеопоток
     * в случае клика в распознанное лицо придёт onGeneralSetted
     * @since 1.10.0
     *
     * @param {Coordinates} coord - относительные координаты клика в видеопоток с лицами
     * @memberof FaceRecognizeService
     *
     * @example <caption>Назначить главного по клику в видеопоток</caption>
     * robot.faceRecognizeService.touchGeneral({x: 0.777, y: 0.616})
     */
  touchGeneral(coord) {
    this.messageChannel.send({
      type: ApiFaceRecognizeMessageType.GENERAL_TOUCH,
      x: coord.x,
      y: coord.y,
    })
  }
  /**
     * Сделать сброс данных о распознанных лицах в диалоге
     * (технический метод для случаев, когда после знакомства робот использует старое обращение)
     * @since 2.4
     *
     * @memberof FaceRecognizeService
     *
     * @example <caption>Сделать сброс данных о распознанных лицах в диалоге</caption>
     * robot.faceRecognizeService.updateFaces()
     */
  updateFaces() {
    this.messageChannel.send({
      type: ApiFaceRecognizeMessageType.FACE_RECOGNIZE_CONTROL,
      clear_faces: null,
    })
  }
  /**
     * Произвести повторное распознавание лиц в кадре
     * @since 1.10.0
     *
     * @memberof FaceRecognizeService
     *
     * @example <caption>Произвести повторное распознавание лиц в кадре</caption>
     * robot.faceRecognizeService.refreshFaces()
     */
  refreshFaces() {
    this.messageChannel.send({
      type: ApiFaceRecognizeMessageType.FACE_RECOGNIZE_CONTROL,
      refresh_faces: null,
    })
  }
  /**
     * Разрешить движение головы для слежения за лицом
     * @since 1.10.0
     *
     * @param {boolean} enabled - True - разрешить, False - запретить
     * @memberof FaceRecognizeService
     *
     * @example <caption>Разрешить движение головы для слежения за лицом</caption>
     * robot.faceRecognizeService.headEnabled(enabled)
     */
  headEnabled(enabled) {
    this.messageChannel.send({
      type: ApiFaceRecognizeMessageType.FACE_RECOGNIZE_CONTROL,
      head_enabled: enabled,
    })
  }
  /**
     * Показывать рамки вокруг распознанных лиц в видеопотоке
     * (можно отключить, например, чтобы сделать фото)
     * @since 1.10.0
     *
     * @param {boolean} enabled - True для включения и False для отключения рамок вокруг лиц
     * @memberof FaceRecognizeService
     *
     * @example <caption>Показывать рамки вокруг распознанных лиц в видеопотоке</caption>
     * robot.faceRecognizeService.enableBorders(enabled)
     */
  enableBorders(enabled) {
    this.messageChannel.send({
      type: ApiFaceRecognizeMessageType.FACE_RECOGNIZE_CONTROL,
      face_borders: enabled,
    })
  }
  /**
     * Назначить главным по trackId
     *
     * @since 1.10.0
     * @param {number} trackId - идентификатор трека лица для назначения главным
     * @memberof FaceRecognizeService
     *
     * @example <caption>Назначить главным по trackId</caption>
     * robot.faceRecognizeService.onInfo(faces => {
     *   const { id_track: trackId } = faces.find(conditionFunction)
     *   robot.faceRecognizeService.setGeneral(trackId)
     * })
     */
  setGeneral(trackId) {
    this.messageChannel.send({
      type: ApiFaceRecognizeMessageType.FACE_RECOGNIZE_CONTROL,
      tracking_face: trackId,
    })
  }
  /**
     * Получить изображение главного
     * в формате base64/PNG
     *
     * @since 1.10.0
     * @return {*}  {Promise<string>}
     * @memberof FaceRecognizeService
     *
     * @example <caption>Получить изображение главного</caption>
     * robot.faceRecognizeService.getGeneralFrame().then((image) => {
     *  if (image !== '') ...
     * }
     */
  getGeneralFrame() {
    return this.execute({
      type: ApiFaceRecognizeMessageType.FACE_RECOGNIZE_CONTROL,
      get_general_frame: null,
    }, this.waiters.generalFrame)
  }
  /**
     * Верифицировать лицо на соответствие с фото
     * ответ придёт на onScore
     *
     * @since 1.10.0
     * @param {number} id - идентификатор лица
     * @param {number} typePerson - тип лица
     * @param {(string | null)} path -путь к фотографии (по умолчанию фото из сканирования паспорта)
     * @return {*}  {Promise<any>}
     * @memberof FaceRecognizeService
     * @alias matchByPhoto
     *
     * @example <caption>Верифицировать лицо на соответствие с фото</caption>
     * robot.faceRecognizeService.verifyByPhoto(id, typePerson, path)
     */
  verifyByPhoto(id, typePerson, path) {
    return this.matchByPhoto(id, typePerson, path)
  }
  /**
     * Верифицировать лицо на соответствие с фото
     * ответ придёт на onScore
     *
     * @since 1.10.0
     * @param {number} id - идентификатор лица
     * @param {number} typePerson - тип лица
     * @param {(string | null)} path -путь к фотографии (по умолчанию фото из сканирования паспорта)
     * @return {*}  {Promise<any>}
     * @memberof FaceRecognizeService
     *
     * @example <caption>Верифицировать лицо на соответствие с фото</caption>
     * robot.faceRecognizeService.matchByPhoto(id, typePerson, path)
     */
  matchByPhoto(id, typePerson, path) {
    return this.execute({
      id,
      type_person: typePerson,
      path,
      type: ApiFaceRecognizeMessageType.FACE_RECOGNIZE_CONTROL,
    }, this.waiters.photoMatch)
  }
}
